import React from 'react';
import { Link } from 'react-router-dom';
import './DepoimentosPage.css';

const DepoimentosPage = () => {
  // Array com todos os depoimentos detalhados
  const depoimentos = [
    {
      nome: "Mariane Souza, 42 anos",
      texto: "Depois de tentar de tudo, finalmente encontrei o que funcionou! Em 21 dias, minha pochete diminuiu visivelmente e me sinto muito mais disposta!",
      imagem: "/images/depoimentos/mariane_provas.png",
      tipo: "Pochete Inflamatória"
    },
    {
      nome: "Luciana Alves, 38 anos",
      texto: "Incrível como algo tão simples funciona tão bem! Minha barriga estava resistente mesmo com academia 3x por semana, mas em 3 semanas com o protocolo ela já mudou drasticamente!",
      imagem: "/images/depoimentos/luciana_alves.jpeg",
      tipo: "Barriga Metabólica"
    },
    {
      nome: "Maria Luísa Silveira, 45 anos",
      texto: "Eu já não acreditava mais que conseguiria eliminar aquela flacidez na barriga depois de 2 gestações. O protocolo me surpreendeu já nas primeiras semanas!",
      imagem: "/images/depoimentos/maria_luisa_silveira.jpeg",
      tipo: "Barriga Avental"
    },
    {
      nome: "Maria Isabel, 51 anos",
      texto: "Mesmo com a idade mais avançada, consegui resultados impressionantes em apenas 21 dias. Minha barriga está mais firme e a inflamação reduziu completamente.",
      imagem: "/images/depoimentos/maria_isabel_vinhando.jpeg",
      tipo: "Barriga Avental"
    },
    {
      nome: "Maria Baia, 36 anos",
      texto: "Pensei que precisaria de exercícios intensos para eliminar minha barriga, mas o protocolo provou o contrário. Resultados visíveis em apenas 3 semanas!",
      imagem: "/images/depoimentos/maria_baiabenicio.jpeg",
      tipo: "Pochete Inflamatória"
    },
    {
      nome: "Camila Santos, 33 anos",
      texto: "O Protocolo 21 Dias mudou minha relação com a alimentação. Aprendi exatamente o que funciona para meu tipo de barriga e os resultados são incríveis!",
      imagem: "/images/depoimentos/1.png",
      tipo: "Barriga Metabólica Inicial"
    },
    {
      nome: "Ana Panao, 47 anos",
      texto: "Já tinha aceitado que aquela gordurinha na barriga era parte da minha vida após os 45, mas esse protocolo provou que eu estava errada! Em 3 semanas já notei diferença!",
      imagem: "/images/depoimentos/ana-panao.jpg",
      tipo: "Barriga Metabólica"
    },
    {
      nome: "Tatiane Cabral, 39 anos",
      texto: "Não precisei fazer dietas malucas nem passar fome. Alimentação inteligente e exercícios estratégicos realmente funcionam! Minha barriga está irreconhecível!",
      imagem: "/images/depoimentos/tatiane-cabral.jpg",
      tipo: "Avental Leve"
    },
    {
      nome: "Juranilde Ferreira, 49 anos",
      texto: "Passei anos lutando contra a gordura localizada. Com o protocolo, finalmente entendi o que estava causando minha barriga e como eliminá-la de vez!",
      imagem: "/images/depoimentos/juranilde.jpg",
      tipo: "Pochete Inflamatória"
    },
    {
      nome: "Adriana Moreira, 41 anos",
      texto: "Transformação incrível em apenas 3 semanas! O protocolo é simples de seguir e os resultados são reais. Minha autoestima voltou!",
      imagem: "/images/depoimentos/adriana.jpg",
      tipo: "Barriga Metabólica"
    },
    {
      nome: "Camila Thomaz, 36 anos",
      texto: "Depois de 2 filhos, achei que nunca mais teria uma barriga bonita. O protocolo provou que eu estava errada. Resultados surpreendentes em 21 dias!",
      imagem: "/images/depoimentos/camila-thomaz.jpg.png",
      tipo: "Avental Leve"
    }
  ];

  return (
    <div className="depoimentos-page">
      <div className="depoimentos-container">
        {/* Bloco 1 - Headline */}
        <div className="result-block block-headline">
          <h1 className="depoimentos-title">Transformações Reais em Apenas 21 Dias</h1>
          <p className="depoimentos-subtitle">
            Veja os resultados de mulheres que eliminaram sua barriga de vez com o Protocolo 21 Dias
          </p>
        </div>
        
        {/* Bloco 2 - Estatísticas */}
        <div className="result-block block-estatisticas">
          <div className="depoimentos-count">
            <div className="count-box">
              <span className="count-number">50.000+</span>
              <span className="count-label">Mulheres Transformadas</span>
            </div>
            <div className="count-box">
              <span className="count-number">21</span>
              <span className="count-label">Dias para Resultados</span>
            </div>
            <div className="count-box">
              <span className="count-number">97%</span>
              <span className="count-label">Taxa de Sucesso</span>
            </div>
          </div>
        </div>
        
        {/* Bloco 3 - Quebra de Paradigma */}
        <div className="result-block block-paradigma">
          <p>
            A verdade é que dietas convencionais, exercícios genéricos e métodos populares falham porque não consideram o tipo específico de barriga que você tem. Cada mulher possui uma composição metabólica e hormonal única que requer uma abordagem personalizada.
          </p>
        </div>
        
        {/* Bloco 4 - Solução e Introdução aos Depoimentos */}
        <div className="result-block block-solucao">
          <p>
            O Protocolo 21 Dias foi desenvolvido para identificar e tratar as causas específicas do seu tipo de barriga. Combinando alimentação estratégica e técnicas de ativação metabólica, conseguimos resultados que outros métodos não alcançam. Veja abaixo os depoimentos reais de mulheres que transformaram seus corpos:
          </p>
        </div>
        
        {/* Bloco 5 - Depoimentos em Grid */}
        <div className="result-block block-depoimentos">
          <h2>Histórias Reais de Sucesso</h2>
          
          <div className="depoimentos-grid">
            {depoimentos.map((depoimento, index) => (
              <div className="depoimento-card" key={index}>
                <div className="depoimento-card-inner">
                  <div className="depoimento-imagem-container">
                    <img 
                      src={depoimento.imagem} 
                      alt={`Transformação de ${depoimento.nome}`} 
                      className="depoimento-image"
                      loading="lazy"
                    />
                    <span className="depoimento-tipo">{depoimento.tipo}</span>
                  </div>
                  <div className="depoimento-conteudo">
                    <h3>{depoimento.nome}</h3>
                    <p className="depoimento-texto">"{depoimento.texto}"</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Bloco 6 - Citação Destacada */}
        <div className="result-block block-citacao">
          <div className="testimonial-quote">
            <blockquote>
              "O Protocolo 21 Dias mudou completamente minha relação com meu corpo. Eu já tinha tentado de tudo para perder a barriga, mas só quando entendi meu tipo de metabolismo é que consegui resultados reais e duradouros!"
            </blockquote>
            <p className="quote-author">- Maria L., 42 anos</p>
          </div>
        </div>
        
        {/* Bloco 7 - Benefícios */}
        <div className="result-block block-produto">
          <h2>O Que Você Recebe no Protocolo 21 Dias:</h2>
          <ul className="beneficios-lista">
            <li><span className="check">✓</span> Guia Digital Completo e Personalizado para você realizar durante 21 dias</li>
            <li><span className="check">✓</span> Receitas anti-inflamatórias rápidas e com ingredientes baratos</li>
            <li><span className="check">✓</span> Shots e Chás metabólicos que aceleram seus resultados</li>
            <li><span className="check">✓</span> Crononutrição: hora certa de comer cada alimento</li>
            <li><span className="check">✓</span> Ativador de Fase Metabólica: Ativar a queima localizada</li>
          </ul>
        </div>
        
        {/* Bloco 8 - Oferta e CTA */}
        <div className="result-block block-oferta">
          <div className="price-container">
            <p className="price-comparison">Investimento menor que uma pizza no mês!</p>
            <div className="price-tags">
              <span className="old-price">R$97,00</span>
              <span className="current-price">R$19,90</span>
            </div>
            <p className="price-installment">ou 12x de R$4,90</p>
          </div>
          
          <a href="#protocolo" className="cta-button">
            QUERO COMEÇAR MINHA TRANSFORMAÇÃO AGORA!
          </a>
          <p className="secure-payment">Pagamento 100% Seguro</p>
        </div>
        
        {/* Bloco 9 - Garantia */}
        <div className="result-block block-garantia">
          <div className="garantia-container">
            <div className="garantia-seal">
              <div className="garantia-circle">7</div>
              <div className="garantia-text-seal">DIAS</div>
            </div>
            <div className="garantia-text">
              <h4>Garantia de Satisfação</h4>
              <p>Se você não começar a ver resultados nos primeiros 7 dias, devolvemos 100% do seu dinheiro. Sem perguntas, sem burocracia!</p>
            </div>
          </div>
        </div>
        
        {/* Bloco 10 - FAQ */}
        <div className="result-block block-faq">
          <h4>Perguntas Frequentes</h4>
          <div className="faq-item">
            <h5>Esse protocolo funciona para qualquer idade?</h5>
            <p>Sim! O protocolo foi desenvolvido para mulheres de todas as idades, com resultados comprovados dos 20 aos 65 anos.</p>
          </div>
          <div className="faq-item">
            <h5>Os resultados do protocolo são rápidos mesmo?</h5>
            <p>Sim! A maioria das mulheres começa a notar mudanças visíveis já na primeira semana, com resultados significativos ao completar os 21 dias. Nosso protocolo foi desenvolvido para promover uma transformação rápida e sustentável.</p>
          </div>
          <div className="faq-item">
            <h5>Já passei dos 40 e estou na menopausa, consigo secar com o programa?</h5>
            <p>Absolutamente! O Protocolo 21 Dias foi especialmente formulado considerando as mudanças hormonais que ocorrem na menopausa. Muitas mulheres acima dos 40, 50 e até 60 anos tiveram resultados impressionantes, pois o método trabalha especificamente com o reequilíbrio hormonal.</p>
          </div>
          <div className="faq-item">
            <h5>Tenho problemas de saúde e/ou hormonais, o programa funciona para mim?</h5>
            <p>Sim! O protocolo foi desenvolvido para trabalhar com diferentes condições de saúde. Os alimentos e técnicas recomendados ajudam a regular o metabolismo e equilibrar os hormônios naturalmente, sendo ideais para quem tem problemas como hipotireoidismo, resistência à insulina, SOP ou desequilíbrios hormonais.</p>
          </div>
          <div className="faq-item">
            <h5>Vou precisar comprar alimentos caros ou especiais?</h5>
            <p>Não! Usamos apenas alimentos comuns que você encontra em qualquer supermercado por preços acessíveis.</p>
          </div>
          <div className="faq-item">
            <h5>Funciona mesmo para quem já tentou de tudo?</h5>
            <p>Especialmente para quem já tentou outros métodos! O Protocolo 21 Dias ataca a causa raiz do seu tipo específico de barriga.</p>
          </div>
        </div>
        
        {/* Bloco 11 - Retornar ao Quiz */}
        <div className="result-block block-retorno">
          <Link to="/" className="voltar-quiz">
            ← Voltar para descobrir meu tipo de barriga
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DepoimentosPage; 